import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { HopeItemExpandedTable } from './HopeItemExpandedTable';
import { Container } from '../../components/layout/WrapperDiv';

type HopeValidationReportProps = {
  rowData: any[];
  hopeDTOProp: string;
};

/** Error-only HOPE report table (no approve chrome). Shared with dashboard Record Visit. */
export const HopeValidationReport = ({
  rowData,
  hopeDTOProp,
}: HopeValidationReportProps) => {
  const { palette } = useTheme();

  return (
    <Container
      id="hope-item-set-container"
      style={{
        border: `solid ${palette?.error?.main} 3px`,
        padding: '5px',
        borderRadius: '5px',
      }}
    >
      <HopeItemExpandedTable rowData={rowData} hopeDTOProp={hopeDTOProp} />
    </Container>
  );
};

export default HopeValidationReport;
